module.exports = __webpack_public_path__ + "static/manuseio-eb063dc0add4996caf88e36fcc8c9457.jpg";